import VehicleApplicationPageComponent from "features/companies/vehicles/application";

export const VehicleApplicationPage = () => <VehicleApplicationPageComponent />;
